import { ReactNode, useCallback } from 'react';
import { components } from '@api/club/generated';

import { CollapseIcon } from '@ui/components/CollapseIcon';
import { TableCell, TableRow } from '@ui/components/Table';

import { ParticipantStartListRow } from '@features/tournament/ui/components/StartList/ParticipantStartListRow';

import styles from './StartList.module.css';

type Props = {
  row: components['schemas']['TeamSeedDto'];
  isToggled: boolean;
  onToggle: (teamId: string) => void;
  showEmail: boolean;
  showGroup: boolean;
  isRcf: boolean;
  groupIsRegion: boolean;
  highlightedUserId?: string;
  renderShieldQuickPeek?: (userId: string) => ReactNode;
};
export function TeamStartListRow({
  row,
  isToggled,
  onToggle,
  showGroup,
  showEmail,
  isRcf,
  groupIsRegion,
  highlightedUserId,
  renderShieldQuickPeek,
}: Props) {
  const handleClick = useCallback(() => {
    onToggle(row.teamId);
  }, [row.teamId, onToggle]);

  let nameColSpan = 3;
  if (showEmail) nameColSpan += 1;
  if (showGroup) nameColSpan += 1;
  if (isRcf) nameColSpan += showEmail ? 2 : 1;

  return (
    <>
      <TableRow className={styles.teamRow} hoverable clickable onClick={handleClick}>
        <TableCell>{row.seedNumber}</TableCell>
        <TableCell colSpan={nameColSpan} className={styles.teamColumn}>
          <div className={styles.teamName}>
            {row.teamName}
            <CollapseIcon toggled={isToggled} />
          </div>
        </TableCell>
      </TableRow>

      {isToggled &&
        row.members.map((m) => (
          <ParticipantStartListRow
            key={m.userId}
            isInTeam={true}
            row={m}
            showEmail={showEmail}
            showGroup={showGroup}
            isRcf={isRcf}
            groupIsRegion={groupIsRegion}
            highlightedUserId={highlightedUserId}
            renderShieldQuickPeek={renderShieldQuickPeek}
          />
        ))}
    </>
  );
}
